/**
 * MODULE: platform/browser/frontend/components/BrowserFollowUpChips.tsx
 * PURPOSE: Quick follow-up commands after partial agent runs (stuck / action limit).
 * DEPENDENCIES: browserAssistantOutcome suggestions
 * PUBLIC_API: BrowserFollowUpChips
 * SIDE_EFFECTS: None (controlled component)
 * AGENT_SAFETY: 🟡 RESTRICTED
 * RECENT: 2026-06-17 [2.2.1411] — Amber follow-up chips after stopped or limit outcomes.
 */

interface BrowserFollowUpChipsProps {
  suggestions: string[];
  disabled?: boolean;
  onSelect: (text: string) => void;
}

export function BrowserFollowUpChips({
  suggestions,
  disabled = false,
  onSelect,
}: BrowserFollowUpChipsProps) {
  if (!suggestions.length) return null;

  return (
    <div className="flex flex-col gap-2" data-testid="browser-follow-up-chips">
      <p className="text-xs font-medium text-amber-900 dark:text-amber-100">
        Suggested follow-ups
      </p>
      <div className="flex flex-wrap gap-2">
        {suggestions.map((prompt) => (
          <button
            key={prompt}
            type="button"
            disabled={disabled}
            onClick={() => onSelect(prompt)}
            className="rounded-full border border-amber-200 bg-amber-50 px-3 py-1 text-left text-xs text-amber-950 hover:bg-amber-100 disabled:opacity-50 dark:border-amber-800 dark:bg-amber-950/40 dark:text-amber-100 dark:hover:bg-amber-900/50"
          >
            {prompt}
          </button>
        ))}
      </div>
    </div>
  );
}
